import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.11 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.87 6.54-6.55-4.1c-.16-.1-.37-.1-.53 0L1.24 6.53c-.24.15-.31.46-.16.69.15.24.45.31.69.16l.27-.17v7.16c0 .28.22.5.5.5h3.8c.28 0 .5-.22.5-.5v-4.21h2.42v4.21c0 .28.22.5.5.5h3.8c.28 0 .5-.22.5-.5V7.21l.28.18a.482.482 0 0 0 .68-.15c.15-.25.08-.56-.15-.7zm-1.81 7.33h-2.8V9.66c0-.28-.22-.5-.5-.5H6.34c-.28 0-.5.22-.5.5v4.21h-2.8V6.58l5.01-3.13 5.01 3.13v7.29z"
    }, null, -1)
  ])))
}
export default { render };